import styled from "styled-components";
//header

export const Header = styled.header`
  /* width: 100%; */
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 1112px) {
    padding: 0 8rem;
  }
  @media (max-width: 1024px) {
    display: none;
  }
`;

export const LogoContainer = styled.div`
  height: 72px;
  display: flex;
  align-items: flex-start;
  margin-left: 3rem;
  img {
    display: block;
    height: 100%;
  }
`;

export const MenuContainer = styled.ul`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 11rem;
  @media (max-width: 1315px) {
    padding: 0 2rem;
  }
`;

export const NavItem = styled.li`
  font-weight: 500;
  font-size: 1.6rem;
  margin: 0 3rem;
  cursor: pointer;
  a {
    color: var(--text-color);
    width: max-content;
  }
  @media (max-width: 1315px) {
    margin: 0 1rem;
  }
`;

export const LoginButtonHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-right: 3rem;
`;
